export default __webpack_public_path__ + "static/media/success_placeholder.7c7ca3f2.svg";